<template>
  <el-dialog
    :model-value="isOpen"
    width="744px"
    @close="$emit('close')"
  >
    <h1 class="tw-mb-8">
      {{ $t('quest.export_dialog_text') }}
    </h1>

    <div>
      <div
        v-for="item in questionnaireExports"
        :key="item.type_id"
        class="tw-transition tw-rounded-3xl tw-mb-2 tw-border tw-border-gray dark:tw-border-dm-gray tw-gap-5"
      >
        <div
          class="tw-p-6 tw-flex tw-justify-between tw-items-center tw-cursor-pointer"
          tabindex="0"
          @click="toggleExpandItem(item)"
        >
          <h2 class="tw-text-h3">
            {{ $capitalize(item.label) }}
          </h2>
          <i-button
            size="small"
            :type="expandedItems.includes(item.type_id) ? 'primary' : 'default'"
            is-icon
          >
            <icon-angle-down
              class="tw-transform tw-transition tw-origin-center"
              :class="expandedItems.includes(item.type_id) ? 'tw-rotate-180' : ''"
            />
          </i-button>
        </div>
        <div
          v-if="expandedItems.includes(item.type_id)"
          class="tw-p-6 tw-pt-0 tw-my-[-12px]"
        >
          <a
            v-for="applicant in item.applicants"
            :key="applicant.id"
            href="#"
            class="tw-flex tw-items-center tw-justify-between tw-mb-4 tw-group"
            @click.prevent.stop="downloadFormStudioExport(item.type_id, applicant.id)"
          >
            <div class="tw-flex tw-items-center">
              <i-user-avatar
                :avatar="applicant.avatar_url && applicant.avatar_url['128'] && `${$baseHost}/${applicant.avatar_url['128']}`"
                :fullname="applicant.fullname"
                size="small"
                class="tw-mr-3"
              />
              <div>
                <div class="tw-font-medium tw-text-dark group-hover:tw-text-primary dark:group-hover:tw-text-dm-primary tw-leading-tight">
                  {{ applicant.fullname }}
                </div>
                <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-leading-tight">
                  {{ applicant.relation_type_name }}
                </div>
              </div>
            </div>
            <div>
              <i-button
                size="small"
                type="white"
                is-icon
              >
                <icon-upload />
              </i-button>
            </div>
          </a>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { downloadFileByUrlV2 } from '@/helpers';

import baseURLv1 from '@/services/APIConfig.js';
import { mapState } from 'vuex';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    questionnaire: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      expandedItems: [],
      baseURLv1,
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
      questionnaireExports: (state) => state.v2.admin.foreigners.foreigner.questionnaireExports,
    }),
  },

  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        try {
          this.$store.dispatch('v2/admin/foreigners/foreigner/loadQuestionnaireExports', {
            foreignerId: this.foreigner.id,
            questionnaireId: this.questionnaire.id,
          });
        } catch (error) {
          console.error(error);
        }
      }
    },
  },

  methods: {
    downloadFileByUrlV2,

    toggleExpandItem(item) {
      const index = this.expandedItems.indexOf(item.type_id);

      if (index !== -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(item.type_id);
      }
    },

    blobToJson(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            resolve(JSON.parse(reader.result));
          } catch (error) {
            reject(error);
          }
        };
        reader.onerror = () => {
          reject(reader.error);
        };
        reader.readAsText(blob);
      });
    },

    async downloadFormStudioExport(itemId, applicantId) {
      try {
        await downloadFileByUrlV2(`${baseURLv1}/foreigner/${this.foreigner.id}/survey/${this.questionnaire.id}/export/form_studio/${itemId}/${applicantId}/`, '', this.$axios);
      } catch (e) {
        // TODO: remove blob error handling when error will be send in json
        const errorData = await this.blobToJson(e.response.data);
        this.$message.error({
          message: errorData.message,
          showClose: true,
          dangerouslyUseHTMLString: true,
        });
      }
    },
  },
};
</script>
